<template>
  <div>
    <div class="bg-vlight-paper overflow-hidden shadow rounded-lg">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6" v-if="session">
        <h3
          class="text-2xl leading-8 font-bebas  tracking-wide text-darkpurple font-extrabold  sm:text-3xl sm:leading-9"
        >
          {{ session.title }} -
          <span class="relative inline-flex h-4 w-4 ml-2">
            <span
              class="relative inline-flex items-center rounded-full h-4 w-4 bg-red-500"
            >
            </span>
          </span>
          <span class="ml-2 text-red-500">Live</span>
        </h3>
      </div>
      <div class="px-4 py-5 sm:p-6 ">
        <div class="flex justify-end mb-2">
          <a
            class="hidden sm:inline-block tracking-wider p-2
            transition duration-150 ease-in-out border-2 border-purple "
            href="#"
            @click="
              () => {
                showChat = !showChat;
              }
            "
          >
            <span v-if="showChat" class="font-bebas text-darkpurple text-xl"
              >Theatre Mode</span
            >
            <span
              v-if="showChat === false"
              class="font-bebas text-darkpurple text-xl"
              >Side By Side</span
            >
          </a>
        </div>

        <div
          class="wrapper"
          :class="{ theatre: !showChat, sidebside: showChat }"
        >
          <div v-if="session.technicalDifficulties" class="video">
            <div class="text-center">
              <h2
                class="text-2xl tracking-wide leading-10 font-extrabold font-bebas text-peach mt-4 sm:text-5xl sm:leading-none md:text-4xl"
              >
                We'll be right back
              </h2>
              <p
                class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
              >
                We are currently experiencing some technical difficulties. We'll
                be back online as soon as possible.
              </p>
            </div>
          </div>
          <div class="video" v-else>
            <div class="mx-auto embed-container">
              <iframe
                :src="session.youtubeEmbedURL"
                class="w-full"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div v-if="false">
                <live-stream-player :session="session" />
              </div>
            </div>
          </div>
          <div class="chatbox">
            <chat-box :session="session" />
          </div>
          <div class="details">
            <p class="mt-6 text-base leading-6 text-gray-800 prose">
                <standard-block-content :blocks="session.description"></standard-block-content>
            </p>
            <div class="mt-10" v-if="hasTutorials">
              <tutorial-videos :session="session"></tutorial-videos>
            </div>
            <div class="mt-8">
              <topic-grid :session="session"></topic-grid>

              <div class="mt-10">

                <session-compatibility-block
                  :session="session"
                ></session-compatibility-block>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatBox from "./ChatBox";
import LiveStreamPlayer from "./LiveStreamPlayer";
import TopicGrid from "./TopicGrid";
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import {mapGetters} from "vuex";
import StandardBlockContent from "./StandardBlockContent";
import TutorialVideos from "./TutorialVideos";

export default {
  name: "LiveSessionPage",
  components: {
    TutorialVideos,
    StandardBlockContent,
    SessionCompatibilityBlock,
    TopicGrid,
    ChatBox,
    LiveStreamPlayer,
  },
  props: {
    session: {
      type: Object
    }
  },
  data: function() {
    return {
      showChat: true,
    };
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    hasTutorials() {
      const tutorials = this.session.tutorials || [];
      return tutorials.length > 0;
    }
  }
};
</script>
<style scoped>
.video {
  grid-area: vd;
}

.chatbox {
  grid-area: cb;
}

.details {
  grid-area: dt;
}
.wrapper {
  display: grid;
  grid-auto-rows: minmax(100px, auto);
  grid-template-columns: 1fr;
  grid-row-gap: 10px;
  grid-template-areas:
    "vd"
    "cb"
    "dt";
}
@media (min-width: 900px) {
  .wrapper.sidebside {
    grid-template-columns: repeat(9, 1fr);
    grid-column-gap: 10px;
    grid-template-areas:
      "vd vd vd vd vd vd cb cb cb"
      "dt dt dt dt dt dt cb cb cb";
  }
  .wrapper.theatre {
    grid-template-columns: minmax(200px, auto);
    grid-column-gap: 10px;
    grid-template-areas:
      "vd"
      "cb"
      "dt";
  }
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
